exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty[data-v-14653330]{margin:0;font-family:Open Sans,sans-serif;font-size:30px;font-weight:100;line-height:1}@media only screen and (min-width:475px){.empty[data-v-14653330]{margin:48px 0 71px;font-size:50px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14653330","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/progress/components/result/components/emptytitle/EmptyTitle.vue
// module id = df905a576f10f63f4f08
// module chunks = 11